import { createFileRoute } from "@tanstack/react-router";

// Non-lazy half of /mission/overview/$tab: the search schema has to be
// declared outside the lazy chunk so the router keeps ?view= (it drops search
// keys the schema omits). The component lives in overview.$tab.lazy.tsx.

export type OverviewView = "table" | "timeline";

type OverviewSearch = {
  // Tabell or Tidslinje, so a link or a reload opens the same view. Absent
  // (sidebar links, old bookmarks): the page falls back to the viewer's last
  // choice and writes it into the URL.
  view?: OverviewView;
};

export const Route = createFileRoute("/_sidebar/mission/overview/$tab")({
  validateSearch: (search: Record<string, unknown>): OverviewSearch =>
    search.view === "table" || search.view === "timeline" ? { view: search.view } : {},
});
